export const ObjectCompositeIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.262 20.2422C11.8478 20.2422 11.512 20.578 11.512 20.9922C11.512 21.4064 11.8478 21.7422 12.262 21.7422V20.2422ZM21.3514 17.8055H22.1014V11.4678H21.3514H20.6014V17.8055H21.3514ZM12.262 20.9922V21.7422H18.1647V20.9922V20.2422H12.262V20.9922ZM21.3514 17.8055H20.6014C20.6014 19.1512 19.5105 20.2422 18.1647 20.2422V20.9922V21.7422C20.3389 21.7422 22.1014 19.9797 22.1014 17.8055H21.3514Z"
				fill="#0047FF"
			/>
			<path
				d="M12.3535 3H18.1668C19.9268 3 21.3535 4.42675 21.3535 6.18672V12V6.18672C21.3535 4.42674 19.9268 3 18.1668 3L12.3535 3Z"
				stroke="#888DA6"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinejoin="round"
			/>
			<path
				d="M12.3535 3H6.54024C4.78026 3 3.35352 4.42757 3.35352 6.18754C3.35352 10.3823 3.35352 13.6177 3.35352 17.8125C3.35352 19.5724 4.78026 21 6.54024 21H12.3535"
				stroke="#0047FF"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M21.3514 11.251C21.7657 11.251 22.1014 11.5868 22.1014 12.001C22.1014 12.4152 21.7657 12.751 21.3514 12.751V11.251ZM15.5455 13.0632H16.2955V13.3091H15.5455H14.7955V13.0632H15.5455ZM15.5455 13.3091H16.2955C16.2955 13.6173 16.5453 13.8672 16.8535 13.8672V14.6172V15.3672C15.7168 15.3672 14.7955 14.4457 14.7955 13.3091H15.5455ZM16.8535 14.6172V13.8672C17.1618 13.8672 17.4116 13.6173 17.4116 13.3091H18.1616H18.9116C18.9116 14.4457 17.9902 15.3672 16.8535 15.3672V14.6172ZM18.1616 13.3091H17.4116V13.0632H18.1616H18.9116V13.3091H18.1616ZM19.2239 12.001V11.251H21.3514V12.001V12.751H19.2239V12.001ZM12.3535 12.001V11.251H14.4832V12.001V12.751H12.3535V12.001ZM18.1616 13.0632H17.4116C17.4116 12.0624 18.223 11.251 19.2239 11.251V12.001V12.751C19.0514 12.751 18.9116 12.8908 18.9116 13.0632H18.1616ZM15.5455 13.0632H14.7955C14.7955 12.8908 14.6557 12.751 14.4832 12.751V12.001V11.251C15.4841 11.251 16.2955 12.0624 16.2955 13.0632H15.5455Z"
				fill="#888DA6"
			/>
			<path
				d="M2.55481 12H5.48324C6.0699 12 6.54548 11.5244 6.54548 10.9378V10.6919C6.54548 9.96947 7.13111 9.3838 7.85358 9.3838C8.57604 9.3838 9.16164 9.96947 9.16164 10.6919V10.9378C9.16164 11.5244 9.63722 12 10.2239 12H12.3536"
				stroke="#0047FF"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M12.3536 3.14918V5.13076C12.3536 5.71742 12.8291 6.193 13.4158 6.193H13.6617C14.3841 6.193 14.9698 6.77864 14.9698 7.5011C14.9698 8.22357 14.3841 8.80917 13.6617 8.80917H13.4158C12.8291 8.80917 12.3536 9.28475 12.3536 9.87141V14.1308C12.3536 14.7175 11.878 15.193 11.2913 15.193H11.0455C10.323 15.193 9.73737 15.7786 9.73737 16.5011C9.73737 17.2236 10.323 17.8092 11.0455 17.8092H11.2913C11.878 17.8092 12.3536 18.2848 12.3536 18.8714V20.9844"
				stroke="#0047FF"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
		</svg>
	)
}
